import React, { useState, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import './ProjectList.css';

const fallbackImage = "https://t3.ftcdn.net/jpg/07/48/61/48/360_F_748614846_odYf50Eo0Zjx9D0SXOBnD0lwg0zSjLhQ.jpg";

const ProjectList = () => {
  const [projects, setProjects] = useState([]);
  const [filteredProjects, setFilteredProjects] = useState([]);
  const [search, setSearch] = useState('');
  const navigate = useNavigate();
  const { id } = useParams(); // Extract the `id` from the URL

  useEffect(() => {
    const fetchProjects = async () => {
      try {
        const response = await fetch('https://pranusha.vercel.app/projects');
        if (!response.ok) {
          throw new Error('Failed to fetch projects');
        }
        const data = await response.json();

        setProjects(data);

        // Filter projects based on `services` field
        if (id) {
          const filtered = data.filter((project) => project.services === id);
          setFilteredProjects(filtered.length === 0 ? data : filtered);
        } else {
          setFilteredProjects(data); // Show all projects if no `id` in the URL
        }
      } catch (error) {
        console.error('Error fetching projects:', error);
      }
    };

    fetchProjects();
  }, [id]); // Re-run effect when `id` changes

  const handleSearch = (event) => {
    const searchTerm = event.target.value.toLowerCase();
    setSearch(searchTerm);

    const filtered = projects.filter((project) =>
      project.title.toLowerCase().includes(searchTerm)
    );
    setFilteredProjects(filtered);
  };

  const handleProjectClick = (id) => {
    navigate(`/projects/${id}`);
  };

  return (
    <div className="project-list-container">
      <div className="search-bar">
        <input
          type="text"
          placeholder="Search our projects..."
          value={search}
          onChange={handleSearch}
        />
      </div>

      <div className="project-grid">
        {filteredProjects.map((project) => {
          const projectImage = project.photo && project.photo.length > 0
            ? project.photo[0].url
            : fallbackImage;

          return (
            <div
              key={project._id}
              className="project-card"
              onClick={() => handleProjectClick(project._id)}
            >
              <img
                src={projectImage}
                alt={project.title}
                className="project-image"
                onError={(e) => e.target.src = fallbackImage} // Handle image errors
                loading="lazy" 
              />
              <div className="project-info">
                <h3 className="project-title">{project.title}</h3>
                <p className="project-location">{project.location}</p>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default ProjectList;
